import { render, staticRenderFns } from "./AboutCarat.vue?vue&type=template&id=df9cddf8&scoped=true&"
var script = {}
import style0 from "./AboutCarat.vue?vue&type=style&index=0&id=df9cddf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9cddf8",
  null
  
)

export default component.exports